import { useConnection } from '@/queries/connections/useConnection'
import { useStytchOrganization } from '@stytch/react/b2b'
import { FC } from 'react'
import { useParams } from 'react-router-dom'

import Elephant from '../../assets/images/Elephant.png'
import { GoogleAdsConnectionMainContent } from './GoogleAdsConnectionMainContent'

export const ConnectionMainContent: FC = () => {
	const { connectionId = '' } = useParams()
	const { organization } = useStytchOrganization()
	const { data: connection, isLoading } = useConnection({
		workspaceId: organization?.organization_id,
		connectionId,
	})

	if (isLoading) {
		return <div>Loading...</div>
	}

	if (!connectionId || !connection) {
		return (
			<div className="flex flex-col items-center justify-center h-full gap-4">
				<img src={Elephant} alt="Welcome" className="w-24 h-24" />
				<h2 className="text-2xl font-semibold text-center">
					Select a connection to see its details
				</h2>
			</div>
		)
	}

	if (connection.platform === 'google_ads') {
		return <GoogleAdsConnectionMainContent connection={connection} />
	}

	return (
		<div className="flex flex-col items-center justify-center h-full gap-4">
			<img src={Elephant} alt="Coming Soon" className="w-24 h-24" />
			<h2 className="text-2xl font-semibold text-center">
				Connection-specific content coming soon!
			</h2>
		</div>
	)
}
